import React from "react";
import { Table } from "@mui/material";
import { ParentProps } from "../types";
import "./styles.scss";

const classNameBase = "scd-table-light";

export default function CustomTableLight(
  props: ParentProps,
): React.JSX.Element {
  const { children } = props;

  return (
    <Table
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {children}
    </Table>
  );
}
